var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStarOfLife } from '@fortawesome/pro-solid-svg-icons/faStarOfLife';
var Label = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0 ", " 0.5rem ", ";\n"], ["\n  color: ", ";\n  margin: 0 ", " 0.5rem ", ";\n"])), function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.highContrast;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});
var Optional = styled.small(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: 0.35rem;\n"], ["\n  color: ", ";\n  margin-left: 0.35rem;\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textTertiary;
});
var RequiredIcon = styled(FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: 0.25rem;\n  margin-bottom: 0.15rem;\n"], ["\n  color: ", ";\n  margin-left: 0.25rem;\n  margin-bottom: 0.15rem;\n"])), function (p) {
  return p.theme.themeName === 'light' ? p.theme.primary : p.theme.primaryB;
});

var InputLabel = function InputLabel(_a) {
  var children = _a.children,
      optional = _a.optional,
      required = _a.required,
      props = __rest(_a, ["children", "optional", "required"]);

  return React.createElement(Label, Object.assign({
    className: "input-label",
    required: required
  }, props), children, optional && React.createElement(Optional, null, React.createElement("em", null, "\u2013 optional")), required && React.createElement(RequiredIcon, {
    icon: faStarOfLife,
    size: "sm",
    fixedWidth: true
  }));
};

export default InputLabel;
var templateObject_1, templateObject_2, templateObject_3;